// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAddressInfoDto } from './IAddressInfoDto';
import {
    IAddressInfoDtoFromJSON,
    IAddressInfoDtoFromJSONTyped,
    IAddressInfoDtoToJSON,
    IAddressInfoDtoToJSONTyped,
} from './IAddressInfoDto';

/**
 * 
 * @export
 * @interface ILockboxMatchEmployeeAggregatorDto
 */
export interface ILockboxMatchEmployeeAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    employee_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    birth_date?: string;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    employment_status?: ILockboxMatchEmployeeAggregatorDtoEmploymentStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    organization_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    claim_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    account_number?: string;
    /**
     * 
     * @type {number}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    available_amount?: number;
    /**
     * 
     * @type {number}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    investments_balance?: number;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    account_status?: ILockboxMatchEmployeeAggregatorDtoAccountStatusEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    label_types?: Set<ILockboxMatchEmployeeAggregatorDtoLabelTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    investment_status?: ILockboxMatchEmployeeAggregatorDtoInvestmentStatusEnum;
    /**
     * 
     * @type {IAddressInfoDto}
     * @memberof ILockboxMatchEmployeeAggregatorDto
     */
    mailing_address?: IAddressInfoDto;
}

/**
* @export
* @enum {string}
*/
export enum ILockboxMatchEmployeeAggregatorDtoEmploymentStatusEnum {
    A = 'A',
    T = 'T',
    L = 'L',
    R = 'R',
    F = 'F',
    C = 'C'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxMatchEmployeeAggregatorDtoAccountStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxMatchEmployeeAggregatorDtoLabelTypesEnum {
    FULL_MATCH = 'FULL_MATCH',
    ACCOUNT_NOT_MATCHED = 'ACCOUNT_NOT_MATCHED',
    SSN_NOT_MATCHED = 'SSN_NOT_MATCHED',
    EMPLOYEE_NAME_NOT_MATCHED = 'EMPLOYEE_NAME_NOT_MATCHED',
    ACCOUNT_NOT_FOUND = 'ACCOUNT_NOT_FOUND',
    LINKED_EMPLOYEE = 'LINKED_EMPLOYEE',
    ADDRESS_NOT_MATCHED = 'ADDRESS_NOT_MATCHED',
    COMMUNICATION_NOT_MATCHED = 'COMMUNICATION_NOT_MATCHED',
    AMOUNT_NOT_MATCHED = 'AMOUNT_NOT_MATCHED'
}
/**
* @export
* @enum {string}
*/
export enum ILockboxMatchEmployeeAggregatorDtoInvestmentStatusEnum {
    INVESTOR_CREATED = 'INVESTOR_CREATED',
    INVESTMENT_PATH_SELECTED = 'INVESTMENT_PATH_SELECTED',
    QUESTIONNAIRE_FILLED = 'QUESTIONNAIRE_FILLED',
    INVESTMENT_AMOUNT_SELECTED = 'INVESTMENT_AMOUNT_SELECTED',
    PENDING_EXTERNAL_CREATION = 'PENDING_EXTERNAL_CREATION',
    ACTIVE = 'ACTIVE'
}


/**
 * Check if a given object implements the ILockboxMatchEmployeeAggregatorDto interface.
 */
export function instanceOfILockboxMatchEmployeeAggregatorDto(value: object): value is ILockboxMatchEmployeeAggregatorDto {
    return true;
}

export function ILockboxMatchEmployeeAggregatorDtoFromJSON(json: any): ILockboxMatchEmployeeAggregatorDto {
    return ILockboxMatchEmployeeAggregatorDtoFromJSONTyped(json, false);
}

export function ILockboxMatchEmployeeAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ILockboxMatchEmployeeAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'employee_name': json['employee_name'] == null ? undefined : json['employee_name'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'birth_date': json['birth_date'] == null ? undefined : json['birth_date'],
        'employment_status': json['employment_status'] == null ? undefined : json['employment_status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'claim_id': json['claim_id'] == null ? undefined : json['claim_id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'account_number': json['account_number'] == null ? undefined : json['account_number'],
        'available_amount': json['available_amount'] == null ? undefined : json['available_amount'],
        'investments_balance': json['investments_balance'] == null ? undefined : json['investments_balance'],
        'account_status': json['account_status'] == null ? undefined : json['account_status'],
        'label_types': json['label_types'] == null ? undefined : new Set(json['label_types']),
        'investment_status': json['investment_status'] == null ? undefined : json['investment_status'],
        'mailing_address': json['mailing_address'] == null ? undefined : IAddressInfoDtoFromJSON(json['mailing_address']),
    };
}

export function ILockboxMatchEmployeeAggregatorDtoToJSON(json: any): ILockboxMatchEmployeeAggregatorDto {
    return ILockboxMatchEmployeeAggregatorDtoToJSONTyped(json, false);
}

export function ILockboxMatchEmployeeAggregatorDtoToJSONTyped(value?: ILockboxMatchEmployeeAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'employee_name': value['employee_name'],
        'ssn': value['ssn'],
        'birth_date': value['birth_date'],
        'employment_status': value['employment_status'],
        'organization_id': value['organization_id'],
        'organization_name': value['organization_name'],
        'claim_id': value['claim_id'],
        'account_id': value['account_id'],
        'account_number': value['account_number'],
        'available_amount': value['available_amount'],
        'investments_balance': value['investments_balance'],
        'account_status': value['account_status'],
        'label_types': value['label_types'] == null ? undefined : Array.from(value['label_types'] as Set<any>),
        'investment_status': value['investment_status'],
        'mailing_address': IAddressInfoDtoToJSON(value['mailing_address']),
    };
}

